module.exports = __webpack_public_path__ + "img/MFT白皮书_33.4ed12ca7.jpg";